import { Grid2 } from '@mui/material'
import CatchmentAction from 'catchment/actions/CatchmentAction'
import { push } from '@lagunovsky/redux-react-router'
import React, { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getStationArrowNav } from 'utils/ActionUtils'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import useUpdateEffect from 'utils/customHook/useUpdateEffect'
import CatchmentForm from './CatchmentForm'
import CatchmentPointsTable from './CatchmentPointsTable'
import CatchmentSDAGETable from './CatchmentSDAGETable'
import { useParams } from 'react-router'

const CatchmentDescriptionApp = () => {
    const { id } = useParams()
    const {
        catchmentProps,
        catchments,
    } = useSelector(store => ({
        catchmentProps: store.CatchmentReducer.catchment,
        catchments: store.CatchmentReducer.catchments,
    }), shallowEqual)

    const [catchment, setCatchment] = useState(catchmentProps)

    const dispatch = useDispatch()

    const [readMode, setReadMode] = useState(id !== 'new')

    useTitle(() => {
        if (id !== 'new') {
            return [{
                title: i18n.catchments,
                href: 'catchment',
            }, {
                title: catchmentProps.code || i18n.unknown,
                href: `station/catchment/${catchmentProps.id}`,
            }, {
                title: i18n.dashboard,
                href: `station/catchment/${catchmentProps.id}`,
            }]
        }
        return [{
            title: i18n.catchments,
            href: 'catchment',
        }, {
            title: i18n.new,
            href: 'station/catchment/new',
        }]
    }, [catchmentProps])

    useUpdateEffect(() => {
        setCatchment(catchmentProps)
    }, [catchmentProps])

    useActions(() => {
        if (readMode) {
            return {
                edit: () => setReadMode(false),
                arrowNav: getStationArrowNav('catchment', catchments, catchmentProps.id, s => dispatch(push(`/station/catchment/${s.id}/description`))),
                delete: () => dispatch(CatchmentAction.deleteCatchment(id)).then(result => result?.delete && dispatch(push('/catchment'))),
            }
        }
        return {
            cancel: () => {
                if (id !== 'new') {
                    setReadMode(true)
                    setCatchment(catchmentProps)
                } else {
                    dispatch(push('/catchment'))
                }
            },
            save: () => {
                if (id === 'new') {
                    dispatch(CatchmentAction.insertCatchment(catchment)).then(result => {
                        if (result?.insert) {
                            dispatch(push(`/station/catchment/${result.id}/description`))
                            setReadMode(true)
                        }
                    })
                } else {
                    dispatch(CatchmentAction.updateCatchment(id, catchment)).then(result => {
                        if (result?.update) {
                            dispatch(CatchmentAction.fetchCatchment(id))
                            setReadMode(true)
                        }
                    })
                }
            },
        }
    }, [readMode, catchment])

    return (
        <Grid2 container spacing={1} style={{ padding: '5 5 100 5' }}>
            <Grid2 size={12}>
                <CatchmentForm catchment={catchment} setCatchment={setCatchment} readMode={readMode} />
            </Grid2>
            <Grid2 size={12}>
                <CatchmentPointsTable catchmentPoints={catchment.catchmentPoints} setCatchment={setCatchment} readMode={readMode} />
            </Grid2>
            <Grid2 size={12}>
                <CatchmentSDAGETable sdages={catchment.sdages} setCatchment={setCatchment} readMode={readMode} />
            </Grid2>
        </Grid2>
    )
}

export default CatchmentDescriptionApp